import { Box, FormField, RangeInput, Select, Tab, Tabs, Text, TextInput, Tip } from "grommet"
import { Close, Image, Paint } from "grommet-icons";
import ShadowSettingsForm from "./sections/ShadowSettingsForm";
import { useContext, useEffect, useState } from "react";
import { SettingType } from "./utils/SettingType";
import { ImageSettingsForm } from "./sections/ImageSettingsForm";
import { BoxShadow } from "../../../icons/BoxShadow";
import { RulerSquare } from "../../../icons/RulerSquare";
import RangeInputWithEdit from "../../../forms/RangeInputWithEdit";
import { rouletteItemBgType } from "../RouletteConstants";
import { FormTypeContext } from "./tab/RouletteItemDesignTab";
import { useTranslation } from "react-i18next";

const typeOptions = [
    { labelKey: 'optionNone', icon: <Close/>, value: rouletteItemBgType.NONE },
    { labelKey: 'optionImage', icon: <Image/>, value: rouletteItemBgType.IMAGE },
    { labelKey: 'optionColorGradient', icon: <Paint/>, value: rouletteItemBgType.COLOR },
]

const RouletteItemBackgroundSettings = () => {

    const { t } = useTranslation('roulette');
    const { backgroundType: type } = useContext(FormTypeContext);

    return (
        <Box gap="medium">
            <FormField label={t('typeLabel')}>
                <Select
                    name="backgroundType"
                    options={typeOptions} 
                    labelKey={(option) => <SettingType option={{ ...option, label: t(option.labelKey) }} />}
                    valueKey={{ key: 'value', reduce: true }}
                    // value={type}
                    // onChange={({ value }) => setType(value)}
                />
            </FormField>
            {type !== rouletteItemBgType.NONE && <BackgroundSettingsForm type={type} />}
        </Box>
    )
}

export default RouletteItemBackgroundSettings;

const BackgroundSettingsForm = ({ type }) => {

    const { t } = useTranslation('roulette');

    return (
        <Box>
            <Tabs>
                <Tab title={type === rouletteItemBgType.IMAGE ? t('imageTabTitle') : t('colorTabTitle')} icon={type === rouletteItemBgType.IMAGE ? <Image/> : <Paint />}>
                    {type === rouletteItemBgType.IMAGE && <ImageSettingsForm label={t('backgroundLabel')} title={t('backgroundBtnTitle')} imageInputName="backgroundImage" imageHueInputName="backgroundImageHue" imageSaturationInputName="backgroundImageSaturation" category="roulette_category_background" />}
                    {type === rouletteItemBgType.COLOR && <ColorSettingsForm />}
                </Tab>
                <Tab title={t('sizeTabTitle')} icon={<RulerSquare />}>
                    <Box background={'background-contrast'} pad={'small'} round={'small'} margin={{ top: 'medium' }}>
                        <FormField label={t('radiusLabel')} noBorder noFocus>
                            <RangeInputWithEdit name="backgroundRadius" type="number" unit={'px'} min={0} max={100} step={1} />
                        </FormField>
                        <FormField label={t('sizeLabel')} noBorder noFocus>
                            <RangeInputWithEdit name="backgroundSize" type="number" unit={'px'} min={10} max={200} step={1} />
                        </FormField>
                    </Box>
                </Tab>
                <Tab title={t('shadowTabTitle')} icon={<BoxShadow />}>
                    <ShadowSettingsForm 
                        shadowColorInputName="backgroundShadowColor"
                        shadowHorizontalOffsetInputName="backgroundShadowHorizontalOffset"
                        shadowVerticalOffsetInputName="backgroundShadowVerticalOffset"
                        shadowBlurInputName="backgroundShadowBlur"
                    />
                </Tab>
            </Tabs>
        </Box>
    )
}

const ColorSettingsForm = () => {

    const { t } = useTranslation('roulette');

    return (
        <Box background={'background-contrast'} pad={'small'} round={'small'} margin={{ top: 'medium' }}>
            <FormField label={t('color1Label')}>
                <TextInput name="backgroundColor1" type="color" />
            </FormField>
            <FormField label={t('color2Label')}>
                <TextInput name="backgroundColor2" type="color" />
            </FormField>
            <FormField label={t('angleLabel')} noBorder noFocus>
                <RangeInputWithEdit name="colorGradientAngle" type="number" unit={'°'} min={0} max={360} step={1} />
            </FormField>
        </Box>
    )
}
